import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Flexer, Icon, Title, Button } from '@ontruck/orc';

const t = {
  title: 'Recurring order configuration',
  edit: 'Edit configuration',
};

class Header extends PureComponent {
  render() {
    const { onEditOrderClick, recurringOrder } = this.props;

    return (
      <header>
        <Flexer.Parent alignItems="center">
          <Flexer.Child flexGrow="1">
            <Flexer.Parent alignItems="center">
              <Icon glyph="repeat" color="greyWolf" size="2.4rem" />
              <Title level="h2" size="M" weight="normal">
                {t.title}
              </Title>
            </Flexer.Parent>
          </Flexer.Child>
          {recurringOrder && recurringOrder.status !== 'CANCELLED' && (
            <Flexer.Child>
              <Button ghost text={t.edit} onClick={onEditOrderClick} />
            </Flexer.Child>
          )}
        </Flexer.Parent>
      </header>
    );
  }
}

Header.propTypes = {
  onEditOrderClick: PropTypes.func.isRequired,
  recurringOrder: PropTypes.any.isRequired,
};

export default Header;
